export interface StateWiseData {
  stateName: string;
  bannerTitle: string;
  bannerSubtitle?: string;
  bannerBackgroundImage?: string;
  bannerBackgroundImageWebp?: string;
  bannerBackgroundImageMobile?: string;
  bannerBackgroundImageWebpMobile?: string;
  bottomImage?: boolean;
  imageTopOffset?: number; // Top offset in pixels for desktop image positioning (default: 0)
  imageObjectPosition?: string; // CSS object-position value for vertical positioning (e.g., "center 40%", "center 60%") - first value should be "center" (default: "center")
  desktopTitleWidth?: string | number; // Width for the title (h1) element on desktop only - can be a CSS value like "600px", "80%", or a number in pixels (default: auto, mobile always uses auto)
}

const stateWiseData: StateWiseData[] = [
  {
    stateName: 'newjersey',
    bannerTitle: 'Ready to find trusted New Jersey roofers without the hassle?',
    bannerSubtitle:
      'Enter your zip code → Get your roof measurements → See what local contractors charge',
    bannerBackgroundImage: 'assets/images/traffic-banner.png',
    bannerBackgroundImageWebp: 'assets/images/traffic-banner.webp',
    bannerBackgroundImageMobile: 'assets/images/traffic-banner-m.png',
    bannerBackgroundImageWebpMobile: 'assets/images/traffic-banner-m.webp',
    bottomImage: true,
    imageTopOffset: 80
  },
  {
    stateName: 'newjersey-v2',
    bannerTitle: 'Need to know what your New Jersey roof is going to cost?',
    bannerSubtitle:
      'Get instant measurements and a ballpark quote from your roof scan, then compare trusted local contractors',
    bannerBackgroundImage: 'assets/images/newjersey.png',
    bannerBackgroundImageWebp: 'assets/images/newjersey.webp',
    bannerBackgroundImageMobile: 'assets/images/newjersey-m.png',
    bannerBackgroundImageWebpMobile: 'assets/images/newjersey-m.webp',
    bottomImage: true,
    imageObjectPosition: 'left 10%',
  },
  {
    stateName: 'california',
    bannerTitle: 'Ready to find trusted California roofers without the hassle?',
    bannerSubtitle:
      'Search by zip code to see local pricing, reviews, and exclusive deals across California',
    bannerBackgroundImage: 'assets/images/traffic-banner.png',
    bannerBackgroundImageWebp: 'assets/images/traffic-banner.webp',
    bannerBackgroundImageMobile: 'assets/images/traffic-banner-m.png',
    bannerBackgroundImageWebpMobile: 'assets/images/traffic-banner-m.webp',
    bottomImage: true,
  },
  {
    stateName: 'california-v2',
    bannerTitle: 'Need to know what your California roof is going to cost?',
    bannerSubtitle:
      'Get instant measurements and a ballpark quote from your roof scan, then compare trusted local contractors',
    bannerBackgroundImage: 'assets/images/newjersey.png',
    bannerBackgroundImageWebp: 'assets/images/newjersey.webp',
    bannerBackgroundImageMobile: 'assets/images/newjersey-m.png',
    bannerBackgroundImageWebpMobile: 'assets/images/newjersey-m.webp',
    bottomImage: true,
    imageObjectPosition: 'left 10%',
  },
  {
    stateName: 'pennsylvania',
    bannerTitle:
      'Ready to find trusted Pennsylvania roofers without the hassle?',
    bannerSubtitle:
      'Enter your zip code → Get your roof measurements → See what local contractors charge',
    bannerBackgroundImage: 'assets/images/traffic-banner.png',
    bannerBackgroundImageWebp: 'assets/images/traffic-banner.webp',
    bannerBackgroundImageMobile: 'assets/images/traffic-banner-m.png',
    bannerBackgroundImageWebpMobile: 'assets/images/traffic-banner-m.webp',
    bottomImage: true,
    imageTopOffset: 80
  },
  {
    stateName: 'pennsylvania-v2',
    bannerTitle: 'Need to know what your Pennsylvania roof is going to cost?',
    bannerSubtitle:
      'Get instant measurements and a ballpark quote from your roof scan, then compare trusted local contractors',
    bannerBackgroundImage: 'assets/images/newjersey.png',
    bannerBackgroundImageWebp: 'assets/images/newjersey.webp',
    bannerBackgroundImageMobile: 'assets/images/newjersey-m.png',
    bannerBackgroundImageWebpMobile: 'assets/images/newjersey-m.webp',
    bottomImage: true,
    imageObjectPosition: 'left 10%',
  },
  {
    stateName: 'washington',
    bannerTitle: 'Ready to find trusted Washington roofers without the hassle?',
    bannerSubtitle:
      'Search by zip code to see local pricing, reviews, and seasonal deals across Washington',
    bannerBackgroundImage: 'assets/images/traffic-banner.png',
    bannerBackgroundImageWebp: 'assets/images/traffic-banner.webp',
    bannerBackgroundImageMobile: 'assets/images/traffic-banner-m.png',
    bannerBackgroundImageWebpMobile: 'assets/images/traffic-banner-m.webp',
    
  },
  {
    stateName: 'wisconsin',
    bannerTitle: 'Ready to find trusted Wisconsin roofers without the hassle?',
    bannerSubtitle:
      'Enter your zip code → Get your roof measurements → See what local contractors charge',
    bannerBackgroundImage: 'assets/images/traffic-banner.png',
    bannerBackgroundImageWebp: 'assets/images/traffic-banner.webp',
    bannerBackgroundImageMobile: 'assets/images/traffic-banner-m.png',
    bannerBackgroundImageWebpMobile: 'assets/images/traffic-banner-m.webp',
    bottomImage: true,
    imageTopOffset: 80
  },
  {
    stateName: 'wisconsin-v2',
    bannerTitle: 'Need to know what your Wisconsin roof is going to cost?',
    bannerSubtitle:
      'Get instant measurements and a ballpark quote from your roof scan, then compare trusted local contractors',
    bannerBackgroundImage: 'assets/images/newjersey.png',
    bannerBackgroundImageWebp: 'assets/images/newjersey.webp',
    bannerBackgroundImageMobile: 'assets/images/newjersey-m.png',
    bannerBackgroundImageWebpMobile: 'assets/images/newjersey-m.webp',
    bottomImage: true,
    imageObjectPosition: 'left 10%'  ,
    desktopTitleWidth: '92.5%'
  
  },
  {
    stateName: 'florida',
    bannerTitle: 'Ready to find trusted Florida roofers without the hassle?',
    bannerSubtitle:
      'Enter your zip code → Get your roof measurements → See what local contractors charge',
    bannerBackgroundImage: 'assets/images/traffic-banner.png',
    bannerBackgroundImageWebp: 'assets/images/traffic-banner.webp',
    bannerBackgroundImageMobile: 'assets/images/traffic-banner-m.png',
    bannerBackgroundImageWebpMobile: 'assets/images/traffic-banner-m.webp',
    bottomImage: true,
    imageTopOffset: 80
  },
  {
    stateName: 'florida-v2',
    bannerTitle: 'Need to know what your Florida roof is going to cost?',
    bannerSubtitle:
      'Get instant measurements and a ballpark quote from your roof scan, then compare trusted local contractors',
    bannerBackgroundImage: 'assets/images/newjersey.png',
    bannerBackgroundImageWebp: 'assets/images/newjersey.webp',
    bannerBackgroundImageMobile: 'assets/images/newjersey-m.png',
    bannerBackgroundImageWebpMobile: 'assets/images/newjersey-m.webp',
    bottomImage: true,
    imageObjectPosition: 'left 10%',  
    desktopTitleWidth: '92.5%' 
  },
];

export const getStateWiseData = (
  stateName: string
): StateWiseData | undefined => {
  const data = stateWiseData.find(item => item.stateName === stateName);
  if (!data) {

    // default data
    return {
      stateName: '',
      bannerTitle: 'Ready to find trusted roofers without the hassle?',
      bannerSubtitle:
        'Enter your zip code → Get your roof measurements → See what local contractors charge',
      bannerBackgroundImage: 'assets/images/traffic-banner.png',
    };
  }
  return data;
};

/**
 * Checks if a state exists in the stateWiseData array
 * @param stateName - State name to check (e.g., "newjersey-v2")
 * @returns true if the state exists, false otherwise
 */
export const stateExists = (stateName: string): boolean => {
  return stateWiseData.some(item => item.stateName === stateName);
};
